<template lang="pug">
  div
    v-card-title
      v-text-field(v-model="search" append-icon="mdi-magnify" label="Search (nama, email, no hp)" single-line hide-details)
    v-data-table(:headers='dataTable.headers' :must-sort="true" :sort-by="pagination.sortBy" :sort-desc="pagination.descending" :items='dataTable.users' item-key="email" class="elevation-1" :search="search")
      template(v-slot:item.department="{ item }")
        template(v-if="Array.isArray(item.department)")
          template(v-for="dept in item.department")
              v-chip(label small style="width:200px;margin:3px;justify-content:space-evenly" text-color="black") {{ dept }}
        v-chip(v-else label small style="width:200px;margin:3px;justify-content:space-evenly" text-color="black") {{ item.department }}
      template(v-slot:item.companies="{ item }")
        template(v-if="Array.isArray(item.companies)")
          template(v-for="comp in item.companies")
              v-chip(label small style="width:200px;margin:3px;justify-content:space-evenly" text-color="black") {{ comp }}
        v-chip(v-else label small style="width:200px;margin:3px;justify-content:space-evenly" text-color="black") {{ item.companies }}    
      template(v-slot:item.actions="{ item }")
        div(style="width:50px")
          router-link(:to="{ name: 'Edit User', query: {email: item.email}}")
            v-icon(small class='mr-2' title='Edit' color="green") edit
          router-link(:to="{}" @click.native="openPJS(item)")
            v-icon(small class='mr-2' title='PJS' color="blue") group
    ModalPJS(v-if="openModal" :openModal="openModal" @closeModal="openModal = false" @selectedPJS="updatePJS" :pjsData="pjs" :leaveUser="selectUser")
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import ModalPJS from "../components/ModalPJS.vue";

export default {
    name: "UserList",
    components: {
      ModalPJS
    },
    props: {
        dataTable: Object
    },
    data() {
      return {
        search: '',
        pagination: {
            sortBy: ["name"],
            descending: [false]
        },
        openModal: false,
        selectUser: {},
        pjs: [],
        department: [],
      };
    },
    computed: {
      ...mapState(["API_URL", "showDrawer"])
    },
    methods: {
      async openPJS(data) {
        this.selectUser = data;
        await axios.get(`${this.API_URL}/v1/requests/pjs?id=${data._id}`, {
            headers: { Authorization: `Bearer ${this.$store.state.token}` },
          }
        ).then((res)=>{
          if(res.status == 200){
            this.pjs = res.data?.data ?? [];
            this.openModal = !this.openModal;
          }
        })
        .catch((err)=>{
          console.log(err)
        });
      },
      async updatePJS(data) {
        await axios.post(`${this.API_URL}/v1/requests/pjs`, {
            leaveUser : this.selectUser._id,
            arrPjs: data.selected,
            dates: data.dates
          }, {
            headers: { Authorization: `Bearer ${this.$store.state.token}` },
          }
        ).then((res)=>{
          if(res.status == 200){
            this.openModal = false;
          }
        })
        .catch((err)=>{
          console.log(err)
        });
      },
    },
}
</script>



v-menu(
  foo
  bar
  foo
  bar
)
  template(foobar)
    v-text-field(foobar)
      ModalDepartment(foobar)
